import dayjs from 'dayjs';
import 'dayjs/locale/ru';

const monthTitle = (date) => {
    const title = date.locale('ru').format('MMMM YYYY');
    return title.charAt(0).toLocaleUpperCase('ru') + title.slice(1);
};

// Группы при сортировке даты по убыванию. Неделя начинается с понедельника.
export const taskDateGroup = (value, now = dayjs()) => {
    if (!value) return 'Без даты';
    const date = dayjs(value).startOf('day');
    if (!date.isValid()) return 'Без даты';
    const today = now.startOf('day');
    if (date.isAfter(today)) return 'Скоро';
    if (date.isSame(today)) return 'Сегодня';
    const weekStart = today.subtract((today.day() + 6) % 7, 'day');
    if (!date.isBefore(weekStart)) return 'Эта неделя';
    if (date.month() === today.month() && date.year() === today.year()) return monthTitle(date);
    return String(date.year());
};
